



















import Vue from 'vue';
import JerseyHeader from '@/components/elements/JerseyHeader.vue';
import JerseyFooter from '@/components/elements/JerseyFooter.vue';
import analytics, { embed } from './libs/gtag';
import { toKebab } from './libs/case';

import Start from '@/views/Start.vue';
import Name from '@/views/Name.vue';
import WhatAreYouHaving from '@/views/WhatAreYouHaving.vue';
import WhereAreYouVacationing from '@/views/WhereAreYouVacationing.vue';
import WhatsYourSignature from '@/views/WhatsYourSignature.vue';
import WhichJerseyShore from '@/views/WhichJerseyShore.vue';
import WhichClub from '@/views/WhichClub.vue';
import WhatAreYouEating from '@/views/WhatAreYouEating.vue';
import GenerateBabyName from '@/views/GenerateBabyName.vue';
import Success from '@/views/Success.vue';
import { trace } from '@/libs/debug';

const tagID: string = 'UA-136754018-3';

embed(tagID);

export default Vue.extend({
  name: 'App',
  components: {
    JerseyHeader,
    JerseyFooter,
    Start,
    Name,
    WhatAreYouHaving,
    WhatsYourSignature,
    WhereAreYouVacationing,
    WhichJerseyShore,
    WhichClub,
    WhatAreYouEating,
    GenerateBabyName,
    Success,
  },
  computed: {
    currentPage() {
      return (this as any).$store.state.currentPage;
    },
  },
  watch: {
    currentPage: {
      handler(to: string, from: string) {
        let pageName: string = toKebab(to);
        pageName = pageName === 'start' ? '' : pageName;
        if (process.env.NODE_ENV !== 'development') {
          const config: any = {
            page_path: `/${pageName}`,
          };
          if (pageName === 'success') {
            config.page_title = 'Jersey Shore Baby Name Generator';
          }
          window.gtag('config', tagID, config);
        } else {
          trace(`tracking page ${pageName}`);
        }
      },
      immediate: true,
    },
  },
});
